<template>
  <el-dialog title="版本升级" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" ref="form" :model="form" :label-width="formLabelWidth">
      <el-form-item label="发布状态" prop="status">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">已发布</el-radio>
          <el-radio :label="0">草稿</el-radio>
        </el-radio-group>
        <p class="tips">仅「已发布」记录会对 APP 端生效；取最新一条已发布记录</p>
      </el-form-item>
      <el-form-item label="更新标题" prop="update_title">
        <el-input v-model="form.update_title" placeholder="弹窗标题，如：发现新版本"></el-input>
      </el-form-item>
      <el-form-item label="版本说明" prop="update_desc">
        <el-input type="textarea" :rows="4" v-model="form.update_desc" placeholder="更新内容，支持换行，如：&#10;1. 修复已知问题&#10;2. 优化用户体验"></el-input>
      </el-form-item>
      <el-form-item label="强制更新" prop="force_update">
        <el-radio-group v-model="form.force_update">
          <el-radio :label="0">可选更新</el-radio>
          <el-radio :label="1">强制更新</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-divider content-position="left">Android</el-divider>
      <el-form-item label="版本号" prop="version_android">
        <el-input v-model="form.version_android" placeholder="如 1.2.0"></el-input>
      </el-form-item>
      <el-form-item label="versionCode" prop="version_code_android">
        <el-input v-model.number="form.version_code_android" placeholder="整数，如 120（推荐填写）"></el-input>
      </el-form-item>
      <el-form-item label="整包地址" prop="pkg_url_android">
        <PackageUrlInput
          v-model="form.pkg_url_android"
          accept=".apk"
          ext="apk"
          placeholder="apk 下载地址，可上传或手动填写外链"
          tip="上传 apk 后自动回填下载地址；也可粘贴 CDN/OSS 外链"
        />
      </el-form-item>
      <el-divider content-position="left">iOS</el-divider>
      <el-form-item label="版本号" prop="version_ios">
        <el-input v-model="form.version_ios" placeholder="如 1.2.0"></el-input>
      </el-form-item>
      <el-form-item label="build 号" prop="version_code_ios">
        <el-input v-model.number="form.version_code_ios" placeholder="整数 build 号"></el-input>
      </el-form-item>
      <el-form-item label="整包地址" prop="pkg_url_ios">
        <el-input v-model="form.pkg_url_ios" placeholder="App Store 或 ipa 地址"></el-input>
      </el-form-item>
      <el-divider content-position="left">热更新 wgt</el-divider>
      <el-form-item label="wgt 地址" prop="wgt_url">
        <PackageUrlInput
          v-model="form.wgt_url"
          accept=".wgt"
          ext="wgt"
          :emit-meta="true"
          placeholder="UniApp 热更新包 .wgt 地址，可上传或手动填写外链"
          tip="上传 wgt 后自动回填地址，并尝试填充 MD5 与文件大小"
          @meta="onWgtMeta"
        />
      </el-form-item>
      <el-form-item label="wgt MD5" prop="wgt_md5">
        <el-input v-model="form.wgt_md5" placeholder="可选，客户端校验完整性"></el-input>
      </el-form-item>
      <el-form-item label="wgt 大小(字节)" prop="wgt_size">
        <el-input v-model.number="form.wgt_size" placeholder="可选，如 1048576"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import AppSettingApi from '@/api/appsetting.js';
  import PackageUrlInput from '@/components/file/PackageUrlInput.vue';
  export default {
    components: { PackageUrlInput },
    data() {
      return {
        formLabelWidth: '130px',
        loading: false,
        dialogVisible: false,
        form: {
          version_android: '',
          version_ios: '',
          version_code_android: 0,
          version_code_ios: 0,
          update_title: '发现新版本',
          update_desc: '',
          force_update: 0,
          status: 1,
          wgt_url: '',
          wgt_md5: '',
          wgt_size: 0,
          pkg_url_android: '',
          pkg_url_ios: '',
        },
      };
    },
    props: ['open'],
    watch: {
      open: function(n, o) {
        if (n != o) {
          this.dialogVisible = this.open;
        }
      }
    },
    methods: {
      onWgtMeta(meta) {
        if (meta.md5) {
          this.form.wgt_md5 = meta.md5;
        }
        if (meta.size) {
          this.form.wgt_size = meta.size;
        }
      },
      onSubmit() {
        let self = this;
        self.loading = true;
        AppSettingApi.addAppUpdate(self.form, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '恭喜你，添加成功',
              type: 'success'
            });
            self.dialogFormVisible(true);
          })
          .catch(error => {
            self.loading = false;
          });
      },
      dialogFormVisible(e) {
        if (e) {
          this.$emit('close', {
            type: 'success',
            openDialog: false
          });
        } else {
          this.$emit('close', {
            type: 'error',
            openDialog: false
          });
        }
      }
    }
  };
</script>

<style scoped>
.tips {
  color: #999;
  font-size: 12px;
  line-height: 1.4;
  margin: 4px 0 0;
}
</style>



// WEBPACK FOOTER //
// src/views/appsetting/appopen/part/update/Add.vue